import Vue from 'vue'
/*import { VueReCaptchaPlugin } from 'vue-recaptcha/enterprise'

// For more options see below
Vue.use(VueRecaptchaPlugin, {
    v2SiteKey: '6LcgXrQlAAAAAC2H213o2fkTLF52wruER2HUsS80',
    v3SiteKey: '6LdXX7QlAAAAABaupy6RY9_CxDACd66HxfvgK1sT',
  })*/

  import LoadScript from 'vue-plugin-load-script';
  Vue.use(LoadScript);